module.exports = __webpack_public_path__ + "img/img_sample_.48842eb.png";